module.exports = __webpack_public_path__ + "static/media/logo-horizontal-orange.10844a9a.svg";